import React from "react";
import ServiceAreaChooser from "../../../components/ServiceAreaChooser";
import Logo from "../../../components/ui/Logo";

export default (props) => {

  return (
    <React.Fragment>

      <div className='row'>
        <div className='col-md-6'>
          <div className='alert alert-info'>
            This app will allow you to take several photographs of the issue and link them to your property.
          </div>
        </div>
      </div>

      <ServiceAreaChooser/>
      <Logo/>

    </React.Fragment>
  );
};
